// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__dGa4X","form":"styles_form__wltB7","formActions":"styles_formActions__D5dar","actionContainer":"styles_actionContainer__-WMWM"};